import { LogoUploader } from "@/components/common/LogoUploader";
import { Card, CardContent, CardHeader, CardTitle } from "@patient-watch/ui/card";
import { cn } from "@/lib/utils";

export interface LogoCardProps {
    id: string;
    name: string;
    title: string;
    logoUrl: string | null;
    isActive: boolean;
    onPasteClick: (id: string) => void;
    onUpload: (id: string, file: File) => Promise<void>;
    isUploading: boolean;
    onClick: () => void;
    onDelete?: () => Promise<void>;
    isDeleting?: boolean;
}

/**
 * A generic card component for displaying and managing logos
 * Can be used for both organisations and diary types
 */
export function LogoCard({
    id,
    name,
    logoUrl,
    isActive,
    onPasteClick,
    onUpload,
    isUploading,
    title,
    onClick: _onClick,
    onDelete,
    isDeleting,
}: LogoCardProps) {
    return (
        <Card className={cn("transition-all duration-200 ease-in-out", isActive ? "ring-2 ring-primary" : "")}>
            <CardHeader>
                <CardTitle>{title}</CardTitle>
            </CardHeader>
            <CardContent className="p-4">
                <LogoUploader
                    id={id}
                    name={name}
                    currentLogoUrl={logoUrl}
                    onUpload={(file) => onUpload(id, file)}
                    isUploading={isUploading}
                    onPasteClick={() => onPasteClick(id)}
                    onDelete={onDelete}
                    isDeleting={isDeleting}
                />
            </CardContent>
        </Card>
    );
}
